import React from "react";

const SuccessIcon = () => (
  <svg
    width="56px"
    height="56px"
    viewBox="0 0 56 56"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-2.7%"
        y="-34.8%"
        width="105.4%"
        height="169.6%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="8"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.792156863   0 0 0 0 0.807843137   0 0 0 0 0.847058824  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="SourceGraphic"></feMergeNode>
        </feMerge>
      </filter>
      <path
        d="M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z M16.9497475,7.46446609 L18.363961,8.87867966 L9.87867966,17.363961 L5.63603897,13.1213203 L7.05025253,11.7071068 L9.87803897,14.5354661 L16.9497475,7.46446609 Z"
        id="path-2"
      ></path>
    </defs>
    <g
      id="Settings---Add-New-User"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Settings---New-User-Added-Alert"
        transform="translate(-140.000000, -221.000000)"
      >
        <g
          id="Alert/Error"
          filter="url(#filter-1)"
          transform="translate(132.000000, 203.000000)"
        >
          <g id="Icon/Success-Container" transform="translate(24.000000, 34.000000)">
            <mask id="mask-3" fill="white">
              <use xlinkHref="#path-2"></use>
            </mask>
            <use
              id="background-2"
              fill="#317D4F"
              fillRule="nonzero"
              xlinkHref="#path-2"
            ></use>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SuccessIcon;
